<template>
    <div class="business-body-div col-12 banCopy" v-show="business_show" ref="business"
        :class="{ 'business-move-up': business_Animate }">
        <div class="business-title-div">
            <h4 class="business-title-text banCopy">业务领域</h4>
        </div>
        <ul class="business-list list-unstyled">
            <li class="business-list-item mouseLink" ref="zoom" v-for="item in businessArr" :key="item"
                @click="gotoBusinessDetails(item.title,item.company_id)">
                <div class="business-item-box">
                    <div class="business-img-box">
                        <img class="business-img" :src="item.img_url">
                    </div>
                    <div class="business-item-title-box">
                        <h5 class="business-item-title">{{ item.title }}</h5>
                    </div>

                    <div class="business-modal-div">
                        <h4 class="business-modal-title">{{ item.title }}</h4>
                        <h6 class="business-modal-content" v-html="item.outline"></h6>
                        <div class="banCopy business-modal-button mouseLink">
                            查看详情
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { isElementNotInViewport } from "../js/utils.js";
export default {
    data() {
        return {
            business_Animate: false,
            business_show: false,
            businessArr: []
        }
    },
    mounted() {
        this.Post();
        // 监听滚动事件
        window.addEventListener("scroll", this.scrollToTop);
        if (screen.width < 991) {
            this.news_show = true;
        }
    },
    beforeRouteLeave(to, form, next) {
        // 离开路由移除滚动事件
        window.removeEventListener('scroll', this.scrollToTop, true);
        next();
    },
    methods: {
        Post() {
            var url = "http://demoapi.hkjt.cn/pages/business.php"

            this.axios.get(url).then(res => {
                // console.log(res.data)
                this.businessArr=res.data
            }).catch(e => {
                if (e.response) {
                    //请求已发出，服务器返回状态码不是2xx。
                    console.info(e.response.data)
                    console.info(e.response.status)
                    console.info(e.response.headers)
                } else if (e.request) {
                    // 请求已发出，但没有收到响应
                    // e.request 在浏览器里是一个XMLHttpRequest实例，
                    // 在node中是一个http.ClientRequest实例
                    console.info(e.request)
                } else {
                    //发送请求时异常，捕捉到错误
                    console.info('error', e.message)
                }
                console.info(e.config)
            })
        },
        // 滚动事件
        scrollToTop() {
            !isElementNotInViewport(this.$refs.business) ? this.business_Animate = true : '';
            // console.log(this.header_Animate);
            if (screen.width < 991) {
                this.business_Animate = false;
                this.business_show = true;
            } else {
                !isElementNotInViewport(this.$refs.business) ? this.business_Animate = true : '';
                this.business_show = true
            }
        },
        gotoBusinessDetails(title,id) {
            this.$router.push({
                name: 'businessDetails',
                query: {
                    title:title,
                    companyid:id
                }
            })
        }
    }
}

$(function () {
    if ($(window).width() < 991) {
        $(".business-modal-div").css("display", "none");
    } else {
        $(".business-item-box").hover(
            function () {
                if ($(window).width() > 991) {
                    var index = $(".business-item-box").index(this);
                    $(".business-modal-div").eq(index).stop().fadeTo("slow", 1, function () {
                        $(this).eq(index).css("animation", "dispaly-box 0.2s");
                        $(this).eq(index).css("display", "flex");
                    })
                } else {
                    $(".business-modal-div").css("display", "none");
                }
            },
            function () {
                if ($(window).width() > 991) {
                    var index = $(".business-item-box").index(this);
                    $(".business-modal-div").eq(index).stop().fadeTo("slow", 0, function () {
                        $(this).eq(index).css("animation", "dispaly-box 0.2s");
                        setTimeout(function () {
                            $(this).eq(index).css("display", "none");
                        }, 200);
                    })
                } else {
                    $(".business-modal-div").css("display", "none");
                }
            }
        );
    }
    /*$(window).resize(function () {
        if ($(window).width() < 991) {
            $(".business-modal-div").css("display", "none");
        } else {
            $(".business-item-box").hover(
                function () {
                    if ($(window).width() > 991) {
                        var index = $(".business-item-box").index(this);
                        $(".business-modal-div").eq(index).stop().fadeTo("slow", 1, function () {
                            $(this).eq(index).css("animation", "dispaly-box 0.2s");
                            $(this).eq(index).css("display", "flex");
                        })
                    } else {
                        $(".business-modal-div").css("display", "none");
                    }
                },
                function () {
                    if ($(window).width() > 991) {
                        var index = $(".business-item-box").index(this);
                        $(".business-modal-div").eq(index).stop().fadeTo("slow", 0, function () {
                            $(this).eq(index).css("animation", "dispaly-box 0.2s");
                            setTimeout(function () {
                                $(this).eq(index).css("display", "none");
                            }, 200);
                        })
                    } else {
                        $(".business-modal-div").css("display", "none");
                    }
                }
            );
        }
    });*/
});

</script>

<style scoped>
.business-title-text{
    color: rgba(54, 54, 54, 0.925);
    font-size: 1.5rem;
}

@keyframes dispaly-box {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes show-box {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes move-up {
    0% {
        opacity: 0;
        transform: translateY(+500px);
    }

    100% {
        opacity: 1;
    }
}

.business-move-up {
    animation: move-up 1.5s;
}

.business-body-div {
    width: 100vm;
    background-color: transparent;
    transition-duration: 0.8s;
}

.business-img-box {
    overflow: hidden;
    width: 100%;
}

.business-title-div {
    display: block;
    width: 100vm;
    text-align: center;
    padding: 6.25rem 6.25rem 3rem 6.25rem; 
}

.business-list-item {
    width: 22.375rem;
    margin-bottom: 3.75rem;
    transition-duration: 0.8s;
    background-color: #fff;
}

@media screen and (min-width:991px) {
    .business-list-item:hover .business-modal-div {
        display: block;
        animation:dispaly-box 0.5s;
    }
}

.business-list {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 75rem;
    margin: 0 auto;
}

.business-item-box {
    height: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 0.375rem;
    /* margin: 0 3.75rem 3.75rem 0; */
    position: relative;
    border-radius: 0.5rem;
    overflow: hidden;
}

.business-item-box:hover .business-img {
    transform: scale(1.2);
    transition-duration: 0.5s;
}

.business-item-box:hover .business-item-title {
    color: #237efe;
}

.business-item-title-box {
    height: 0;
    padding-top: 50%;
    position: relative;
}

.business-item-title {
    color: #363636;
    letter-spacing: 0.2rem ;
    position: absolute;
    top: 1rem;
    left: 1rem;
    transition-duration: 0.4s;
}

.business-img {
    width: 100%;
    transition-duration: 0.3s;
}

.business-modal-div {
    background-color: #2D2D2DB3;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    transform: all 0.3s;
    color: #fff;
    display: none;
    text-align: center;
    flex-direction: column;
    padding: 0 2.3rem 0 2.3rem;
    animation:show-box 0.5s;
}

.business-modal-title {
    color: #fff;
    width: 100%;
    margin: 2rem 0 2rem 0;
    font-size: 1.25rem;
}

.business-modal-content {
    color: #fff;
    width: 100%;
    line-height: 1.8rem;
    letter-spacing: 0.15rem;
}

.business-modal-button {
    /* width: 100%; */
    position: absolute;
    bottom: 1rem;
    width: 35%;
    height: 2rem;
    background-color: #409EFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.2rem;
    margin: 0 auto;
    left: 34%;
}

@media screen and (max-width:1218px) {
    .business-list {
        width: 100%;
    }

    .business-list-item {
        width: 40%;
        transition-duration: 0.8s;
    }

    .business-body-div {
        background-color: #fff;
        transition-duration: 0.8s;
    }
}

@media screen and (max-width:570px) {
    .h5,h5{
        font-size: 1rem;
        transition-duration: 0.4s;
    }
}
</style>